import type { DialogProps } from "./interfaces";
import { FC, Fragment } from "preact/compat";
import { Transition, Dialog as _HeadlessDialog } from "@headlessui/react";

// there's an issue with headlessui types
// TS doesn't recognize className prop for Dialog component
//
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const HeadlessDialog = _HeadlessDialog as any;

const Dialog: FC<DialogProps> = ({ open, onClose, children }) => (
    <Transition appear show={open}>
        <HeadlessDialog as="div" className="relative z-50" onClose={onClose}>
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div
                    aria-hidden="true"
                    className="fixed z-50 left-[50px] top-[50px] right-0 bottom-0 bg-gray-500 bg-opacity-30 backdrop-blur"
                />
            </Transition.Child>
            <div className="fixed z-50 left-[50px] top-[50px] right-0 bottom-0 overflow-y-auto">
                <div className="flex items-center justify-center min-h-full p-0 lg:p-4">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-12"
                        enterTo="opacity-100 translate-y-0"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-12"
                    >
                        <HeadlessDialog.Panel className="flex">
                            {children}
                        </HeadlessDialog.Panel>
                    </Transition.Child>
                </div>
            </div>
        </HeadlessDialog>
    </Transition>
);

export default Dialog;
